<template>
    <b-overlay :show="busy" rounded="sm">

        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable">
                <b-card class="w-100pct">

                    <b-card-body class="py-0 px-0">

                        <b-tabs class="gridtabs" v-model="tabindex">

                            <b-tab>
                                <template #title>
                                    <i class="fa fa-wpforms text-info mr-1"></i>
                                    {{ item.invoiceno }}
                                </template>

                                <b-row class="w-100pct mt-3">
                                    <b-col cols="12">
                                        <i @click="showHeader = !showHeader" id="header-tooltip"
                                            :class="showHeader ? 'fa fa-arrow-up' : 'fa fa-arrow-right'"
                                            class="fa-2x text-black"></i>
                                        <b-link @click="showHeader = !showHeader" class="h5 strong text-orange ml-2"
                                            v-text="showHeader ? 'Hide Header' : 'Show Header'"></b-link>
                                    </b-col>
                                    <b-collapse v-model="showHeader">
                                        <p class="pt-3 px-3 " v-if="item.invoiceno == '*new'">
                                            <b-row class="pb-3">
                                                <b-col cols="12" class="strong text-2x">
                                                    Create invoice from booking, GDS or setup the transaction as needed.
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col cols="12" sm="6">
                                                    <b-form-group label="Booking Form ID" label-for="bookingformid"
                                                        label-cols="12">
                                                        <b-input-group>
                                                            <b-row no-gutters>
                                                                <b-col cols="auto">
                                                                    <b-button size="sm" variant="outline-primary"
                                                                        @click="item.bookingformid = null">
                                                                        <i class="fa fa-upload"></i>
                                                                    </b-button></b-col>
                                                                <b-col>
                                                                    <treeselect instanceId="nlcode" type="number"
                                                                        v-model="item.bookingformid" :clearable="true"
                                                                        :options="bookingform_options"></treeselect>
                                                                    <!-- <treeselect placeholder="Select booking..."
                                                                        searchPromptText="Type at least 3 chars..."
                                                                        v-model="item.bookingformid" :clearable="true"
                                                                        :async="true"
                                                                        :load-options="treeselect_loadBookingform"
                                                                        :show-count="true"
                                                                        :flatten-search-results="true"
                                                                        :disable-branch-nodes="true" :matchKeys="['id']"
                                                                        search-nested :disabled="readonly">
                                                                        <div slot="value-label" slot-scope="{ node }">
                                                                            {{ node.raw.id }}
                                                                        </div>
                                                                    </treeselect> -->
                                                                </b-col>
                                                                <b-col cols="auto">
                                                                    <b-button size="sm" variant="outline-primary"
                                                                        @click="bookingforms_load">
                                                                        <i class="fa fa-refresh"></i>
                                                                    </b-button></b-col>

                                                            </b-row>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6">
                                                    <b-form-group label-cols="12"
                                                        label="GDS Locator(s) or TicketNo(s) ( 6 alpha or 10 / 13 numeric allowed )"
                                                        label-size="sm" class="mb-0">
                                                        <b-input-group>
                                                            <b-row no-gutters class="w-100pct">
                                                                <b-col cols="auto">
                                                                    <b-button size="sm" variant="outline-primary"
                                                                        @click="load_data('associatedno')">
                                                                        <i
                                                                            :class="load_busy ? 'fa fa-spinner fa-spin' : 'fa fa-upload'"></i>
                                                                    </b-button></b-col>
                                                                <b-col>
                                                                    <b-form-tags input-id="associatedno"
                                                                        v-model="item.associatedno"
                                                                        tag-variant="primary" separator=" ,;/"
                                                                        placeholder="" size="sm" class="h-29"
                                                                        add-button-text="+" add-on-change
                                                                        remove-on-delete
                                                                        add-button-variant="outline-primary"></b-form-tags>
                                                                </b-col>
                                                                <b-col cols="auto">
                                                                    <b-input-group-append>
                                                                        <b-button size="sm" variant="outline-secondary"
                                                                            @click="item.associatedno = null">
                                                                            <i class="fa fa-remove"></i>
                                                                        </b-button>
                                                                    </b-input-group-append>
                                                                </b-col>
                                                            </b-row>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        <div class="divider mx-3" v-if="item.invoiceno == '*new'"> </div>
                                        </p>

                                        <p class="pb-3 px-3">

                                            <b-row>

                                                <b-col cols="12" sm="4" md="3">
                                                    <b-form-group label-cols="12" label="Invoice Date" label-size="sm">
                                                        <b-input-group>
                                                            <daterangepicker style="width:auto !important" size="sm"
                                                                ref="date" v-model="mapper_date_at" :opens="'right'"
                                                                :single-date-picker="'single'" :locale-data="{
                                                                    direction: 'ltr',
                                                                    format: 'dd/mm/yy HH:MM',
                                                                    daysOfWeek: [
                                                                        'Sun',
                                                                        'Mon',
                                                                        'Tue',
                                                                        'Wed',
                                                                        'Thu',
                                                                        'Fri',
                                                                        'Sat',
                                                                    ],
                                                                    monthNames: [
                                                                        'January',
                                                                        'February',
                                                                        'March',
                                                                        'April',
                                                                        'May',
                                                                        'June',
                                                                        'July',
                                                                        'August',
                                                                        'September',
                                                                        'October',
                                                                        'November',
                                                                        'December',
                                                                    ],
                                                                    firstDay: 1,
                                                                }" :ranges="false" :showDropdowns="true"
                                                                :linkedCalendars="true" :timePicker="true"
                                                                :timePicker24Hour="true" :time-picker-increment="1">
                                                            </daterangepicker>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="mapper_date_at = null">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>

                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Prefix" label-for="invoice_type"
                                                        label-cols="12">
                                                        <treeselect id="prefix" placeholder="Select prefix type..."
                                                            :clearable="false" v-model="item.prefix"
                                                            :options="prefix_options" :disable-branch-nodes="true"
                                                            :show-count="true" :default-expand-level="1" />
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label-cols="12" label="CreditNo" label-size="sm"
                                                        :disabled="readonly">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.refcredit"
                                                                :debounce="sllines.debounce"
                                                                placeholder="creditNo"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" squared variant="outline-secondary"
                                                                    :disabled="readonly" @click="item.refcredit = null">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label-cols="12" label="InvoiceNo" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.invoiceno"
                                                                :debounce="sllines.debounce" placeholder="New..."
                                                                :disabled="true"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    :disabled="readonly" @click="item.invoiceno = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Total Taxes" label-for="taxes" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="item.taxes"
                                                                placeholder="Taxes" size="sm"
                                                                :disabled="readonly_formula"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled="readonly_formula"
                                                                    variant="outline-secondary"
                                                                    @click="item.taxes = '0.00'">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Total VAT" label-for="vat" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="item.salevat"
                                                                placeholder="VAT" size="sm"
                                                                :disabled="readonly_formula"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled="readonly_formula"
                                                                    variant="outline-secondary"
                                                                    @click="item.salevat = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Amount GBP" label-for="saletotal"
                                                        label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="item.amount"
                                                                placeholder="Amount" size="sm"
                                                                :disabled="readonly_formula"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled="readonly_formula"
                                                                    variant="outline-secondary"
                                                                    @click="item.saletotal = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Due GBP" label-for="due" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="item.due"
                                                                placeholder="Due" size="sm"
                                                                :disabled="readonly_formula"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled="readonly_formula"
                                                                    variant="outline-secondary" @click="item.due = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>

                                            <b-row>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Your Ref/PO (include *BN)"
                                                        label-for="yourrefbn" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="item.yourrefbn"
                                                                placeholder="Your Ref/PO" size="sm" trim
                                                                :disabled="readonly"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled="readonly"
                                                                    variant="outline-secondary"
                                                                    @click="item.yourrefbn = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Your Ref/PO" label-for="yourref"
                                                        label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="item.yourref"
                                                                placeholder="Your Ref/PO" size="sm" trim
                                                                :disabled="true"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled="true"
                                                                    variant="outline-secondary"
                                                                    @click="item.yourref = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Booker" label-for="booker" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="item.booker"
                                                                placeholder="Booker" size="sm" trim
                                                                :disabled="true"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled="true"
                                                                    variant="outline-secondary"
                                                                    @click="item.booker = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">

                                                    <b-form-group label="Agent" label-for="agent" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="item.agent"
                                                                placeholder="Your Ref/PO" size="sm" trim
                                                                :disabled="readonly"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled="readonly"
                                                                    variant="outline-secondary"
                                                                    @click="item.agent = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>


                                            </b-row>

                                            <b-row>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                                                        <treeselect placeholder="Select slac..."
                                                            searchPromptText="Type at least 3 chars..."
                                                            v-model="item.slac" :clearable="true" :async="true"
                                                            :load-options="treeselect_loadSLAC" :show-count="true"
                                                            :flatten-search-results="true" :disable-branch-nodes="true"
                                                            :matchKeys="['id']" search-nested :disabled="readonly">
                                                            <div slot="value-label" slot-scope="{ node }">
                                                                {{ node.raw.id }}
                                                            </div>
                                                        </treeselect>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label-cols="12" label="Event" label-size="sm">
                                                        <treeselect placeholder="Select event..."
                                                            v-model="item.eventcode" :clearable="true" :async="true"
                                                            :load-options="treeselect_loadEvent" :show-count="true"
                                                            searchPromptText="Type at least 4 chars..."
                                                            :flatten-search-results="true" :disable-branch-nodes="true"
                                                            :matchKeys="['id']" search-nested :disabled="readonly">
                                                            <div slot="value-label" slot-scope="{ node }">
                                                                {{ node.raw.id }}
                                                            </div>
                                                        </treeselect>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label-cols="12" label="DateTravel" label-size="sm"
                                                        :disabled="true">
                                                        <b-input-group>
                                                            <b-form-input :value="item.travel_at
                                                                ? this.$helpers.datefield(item.travel_at)
                                                                : null
                                                                " :disabled="true"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" squared variant="outline-secondary"
                                                                    :disabled="true" @click="item.travel_at = null">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Supplier Type" label-for="type"
                                                        label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="item.bltype"
                                                                placeholder="Supplier Type" size="sm" trim
                                                                :disabled="true"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled=true
                                                                    variant="outline-secondary" @click="item.type = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Analysis 1" label-for="analysis1"
                                                        label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="item.analysis1"
                                                                placeholder="Analysis 1" size="sm" trim
                                                                :disabled="readonly"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled="readonly"
                                                                    variant="outline-secondary"
                                                                    @click="item.analysis1 = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12" sm="6" md="4" xl="3">
                                                    <b-form-group label="Analysis 2" label-for="analysis2"
                                                        label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="item.analysis2"
                                                                placeholder="Analysis 2" size="sm" trim
                                                                :disabled="readonly"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled="readonly"
                                                                    variant="outline-secondary"
                                                                    @click="item.analysis2 = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>


                                            </b-row>



                                        </p>
                                    </b-collapse>
                                </b-row>

                                <b-tooltip target="header-tooltip" triggers="hover">Use show header to display the
                                    rolled up summary for this invoice.
                                </b-tooltip>

                                <!-- <p class="py-2 px-0"> -->
                                <b-row v-if="item.id" class="mt-3 mb-3 mx-n3">
                                    <b-col cols="auto" class="mr-auto"> <b-list-group horizontal="md" size="sm">
                                            <b-list-group-item variant="dark"><span class="list-label">To:
                                                    {{ item.slac }}</span> {{ item.to }}</b-list-group-item>
                                            <b-list-group-item variant="dark"><span class="list-label">Your
                                                    Ref/PO:</span>{{ item.yourref }}</b-list-group-item>
                                            <b-list-group-item variant="dark"><span
                                                    class="list-label">InvoiceNo:</span>{{
                                                        item.invoiceno }}</b-list-group-item>
                                            <b-list-group-item variant="dark"><span class="list-label">Date:</span>{{
                                                $moment.unix(item.date_at * 0.001).format("DD-MMM-YYYY")
                                                }}</b-list-group-item>

                                            <!-- <b-list-group-item variant="dark"><span class="list-label">Due
                                                    on:</span>{{ $moment.unix(item.due_at * 0.001).format("DD/MM/YYYY")
                                                }}</b-list-group-item> -->

                                        </b-list-group></b-col>

                                    <b-col cols="auto" v-if="selection.length == 1">

                                        <b-list-group horizontal="md">
                                            <b-list-group-item
                                                :variant="changed ? 'dark-warning' : 'dark-primary'"><span
                                                    class="list-label">Amount
                                                    GBP:</span><span class="h6 strong">{{ amount | currency("")
                                                    }}</span></b-list-group-item>
                                            <b-list-group-item
                                                :variant="changed ? 'dark-warning' : 'dark-primary'"><span
                                                    class="list-label">Due
                                                    GBP:</span><span class="h6 strong">{{
                                                        due | currency("")
                                                    }}</span></b-list-group-item>
                                        </b-list-group></b-col>


                                    <b-col cols="auto" v-if="selection.length > 1"> <b-list-group horizontal="md"
                                            size="sm">
                                            <b-list-group-item variant="dark-danger"><span
                                                    class="list-label">Invoices:</span><span class="strong h6">{{
                                                        selection.length
                                                    }}</span></b-list-group-item>
                                        </b-list-group></b-col>

                                    <div>

                                    </div>
                                </b-row>

                                <p v-if="selection.length == 1">
                                    <b-tabs>
                                        <b-tab>
                                            <template #title>
                                                <div class="badgecontainer pr-1 mr-1 w-80px">
                                                    <i :class="sllines.icon" class="ml-1 mr-1"></i>{{ sllines.title }}
                                                    <b-badge variant="white" class="edit_tab">
                                                    </b-badge>

                                                </div>
                                            </template>
                                            <b-row>
                                                <b-col>
                                                    <d-table classdivtable="availtable datatable nested"
                                                        refid="segments" :icon="sllines.icon" :busy="sllines.busy"
                                                        :selectall="sllines.selectall" :tools="sllines.tools"
                                                        :badges="sllines.badges" :fields="sllines.fields"
                                                        :items="sllines.items" :page="sllines.page" :showpages="false"
                                                        @load="sllines_load" @click="sllines_click"
                                                        @select="sllines_select">
                                                    </d-table>
                                                </b-col>
                                            </b-row>

                                            <b-tabs v-if="sllines.edit" class="gridtabs mt-2">
                                                <b-tab>
                                                    <template #title>
                                                        <span class="text-primary">{{sllines.items.map(o =>
                                                            o.line).indexOf(sllines.item.line) + 1
                                                            }}.</span>
                                                        <i :class="'fa fa fa-arrows-h text-info'"
                                                            class="text-primary ml-1 mr-1"></i>
                                                        <span class="text-warning">&lt;{{ selection.length == 0 ? "new"
                                                            : "line edit" }}&gt;</span>&nbsp;


                                                    </template>

                                                    <p class="py-0 px-0 ">
                                                        <b-card class="nopadding mt-0 "><b-card-body>

                                                                <div class="px-0 mt-2">

                                                                    <b-row>

                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group
                                                                                v-if="mapper_ticketno.length > 0 && !mapper_ticketno_input"
                                                                                label-cols="12" label="TicketNo"
                                                                                label-size="sm">
                                                                                <b-input-group
                                                                                    class="treeselect_all justify-content-end pr-2px">
                                                                                    <span style="padding-top: 0.3em"
                                                                                        class="text-primary"
                                                                                        id="inputlist-tooltip">Input</span>
                                                                                    <b-form-checkbox id="inputlist"
                                                                                        v-model="mapper_ticketno_input"
                                                                                        class="z-0">
                                                                                    </b-form-checkbox>
                                                                                </b-input-group>
                                                                                <treeselect
                                                                                    placeholder="Select ticketno..."
                                                                                    searchPromptText="Type at least 6 chars..."
                                                                                    v-model="mapper_ticketno"
                                                                                    :clearable="true" :multiple="true"
                                                                                    :async="true"
                                                                                    :load-options="treeselect_loadTicket"
                                                                                    :show-count="true"
                                                                                    :flatten-search-results="true"
                                                                                    :disable-branch-nodes="true"
                                                                                    :matchKeys="['id']" search-nested
                                                                                    :disabled="readonly">
                                                                                    <div slot="value-label"
                                                                                        slot-scope="{ node }">
                                                                                        {{ node.raw.id }}
                                                                                    </div>
                                                                                </treeselect>
                                                                            </b-form-group>

                                                                            <b-form-group v-else label="TicketNo"
                                                                                label-for="ticketno" label-cols="12">
                                                                                <b-input-group
                                                                                    class="treeselect_all justify-content-end pr-2px">
                                                                                    <span style="padding-top: 0.3em"
                                                                                        class="text-primary"
                                                                                        id="inputlist-tooltip">Input</span>
                                                                                    <b-form-checkbox id="inputlist"
                                                                                        v-model="mapper_ticketno_input"
                                                                                        class="z-0">
                                                                                    </b-form-checkbox>
                                                                                </b-input-group>
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        v-model="sllines.item.ticketno"
                                                                                        placeholder="Ticketno" size="sm"
                                                                                        trim
                                                                                        :disabled="readonly"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.ticketno = ''"
                                                                                            :disabled="readonly">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Ticket Type"
                                                                                label-for="tickettype" label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        v-model="sllines.item.tickettype"
                                                                                        placeholder="Ticket Type"
                                                                                        size="sm"
                                                                                        :disabled="true"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            :disabled="true"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.tickettype = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                        <!-- 

                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group
                                                                                v-if="sllines.item.blac == 'VOLANTEUS' || sllines.item.blac == 'BSP'"
                                                                                label-cols="12" label="TicketNo"
                                                                                label-size="sm">
                                                                                <treeselect placeholder="Select ticketno..."
                                                                                    searchPromptText="Type at least 6 chars..."
                                                                                    v-model="mapper_ticketno"
                                                                                    :clearable="true" :multiple="true"
                                                                                    :async="true"
                                                                                    :load-options="treeselect_loadTicket"
                                                                                    :show-count="true"
                                                                                    :flatten-search-results="true"
                                                                                    :disable-branch-nodes="true"
                                                                                    :matchKeys="['id']" search-nested
                                                                                    :disabled="readonly">
                                                                                    <div slot="value-label"
                                                                                        slot-scope="{ node }">
                                                                                        {{ node.raw.id }}
                                                                                    </div>
                                                                                </treeselect>
                                                                            </b-form-group>

                                                                            <b-form-group v-else label="TicketNo"
                                                                                label-for="ticketno" label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        v-model="sllines.item.ticketno"
                                                                                        placeholder="Ticketno" size="sm"
                                                                                        trim
                                                                                        :disabled="readonly"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.ticketno = ''"
                                                                                            :disabled="readonly">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col> -->

                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Passenger"
                                                                                label-for="passenger" label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        :debounce="sllines.debounce"
                                                                                        v-model="sllines.item.passenger"
                                                                                        placeholder="Passenger"
                                                                                        size="sm" trim
                                                                                        :disabled="readonly"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.passenger = ''"
                                                                                            :disabled="readonly">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Route"
                                                                                label-for="route" label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        :debounce="sllines.debounce"
                                                                                        v-model="sllines.item.route"
                                                                                        placeholder="Route" size="sm"
                                                                                        trim
                                                                                        :disabled="readonly"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.route = ''"
                                                                                            :disabled="readonly">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col cols="12" sm="4" md="3">
                                                                            <b-form-group label-cols="12"
                                                                                label="DateTravel" label-size="sm">
                                                                                <b-input-group>
                                                                                    <daterangepicker class="w-auto sm"
                                                                                        size="sm" ref="travel_at"
                                                                                        v-model="mapper_travel_at"
                                                                                        :opens="'right'" :locale-data="{
                                                                                            direction: 'ltr',
                                                                                            format: 'dd/mm/yy',
                                                                                            daysOfWeek: [
                                                                                                'Sun',
                                                                                                'Mon',
                                                                                                'Tue',
                                                                                                'Wed',
                                                                                                'Thu',
                                                                                                'Fri',
                                                                                                'Sat',
                                                                                            ],
                                                                                            monthNames: [
                                                                                                'January',
                                                                                                'February',
                                                                                                'March',
                                                                                                'April',
                                                                                                'May',
                                                                                                'June',
                                                                                                'July',
                                                                                                'August',
                                                                                                'September',
                                                                                                'October',
                                                                                                'November',
                                                                                                'December',
                                                                                            ],
                                                                                            firstDay: 1,
                                                                                            applyLabel: 'OK',
                                                                                            cancelLabel: 'Cancel',
                                                                                        }" :ranges="false"
                                                                                        :showDropdowns="true"
                                                                                        :single-date-picker="'single'"
                                                                                        :timePicker="false"
                                                                                        :timePicker24Hour="false"
                                                                                        :time-picker-increment="1">
                                                                                    </daterangepicker>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            @click="mapper_travel_at = {
                                                                                                startDate: null,
                                                                                                endDate: null,
                                                                                            }
                                                                                                ">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col cols="6">
                                                                            <b-form-group label="Details"
                                                                                label-for="detail" label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        :debounce="sllines.debounce"
                                                                                        v-model="sllines.item.moreinfo"
                                                                                        placeholder="Details" size="sm"
                                                                                        :disabled="readonly"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            :disabled="readonly"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.moreinfo = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col cols="6">
                                                                            <b-form-group label="Remark"
                                                                                label-for="remark" label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        :debounce="sllines.debounce"
                                                                                        v-model="sllines.item.remark"
                                                                                        placeholder="Remark" size="sm"
                                                                                        trim
                                                                                        :disabled="readonly"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.remark = ''"
                                                                                            :disabled="readonly">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Qty" label-for="qty"
                                                                                label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="number"
                                                                                        :debounce="sllines.debounce"
                                                                                        :min="min_qty" :max="max_qty"
                                                                                        v-model="sllines.item.qty"
                                                                                        placeholder="Qty" size="sm" trim
                                                                                        :disabled="readonly"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.qty = '0'"
                                                                                            :disabled="readonly">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Unit Price Ex VAT"
                                                                                label-for="lineprice" label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        :debounce="sllines.debounce"
                                                                                        v-model="sllines.item.lineprice"
                                                                                        placeholder="Unit Price Ex VAT"
                                                                                        size="sm" trim
                                                                                        :disabled="readonly"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.lineprice = '0.00'"
                                                                                            :disabled="readonly">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Unit Taxes"
                                                                                label-for="linetaxes" label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        :debounce="sllines.debounce"
                                                                                        v-model="sllines.item.linetaxes"
                                                                                        placeholder="Unit Taxes"
                                                                                        size="sm" trim
                                                                                        :disabled="readonly"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.linetaxes = '0.00'"
                                                                                            :disabled="readonly">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Unit Subtotal Ex VAT"
                                                                                label-for="linesubtotal"
                                                                                label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        :debounce="sllines.debounce"
                                                                                        v-model="sllines.item.linesubtotal"
                                                                                        placeholder="Unit Subtotal Ex VAT"
                                                                                        size="sm" trim
                                                                                        :disabled="readonly"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.linesubtotal = '0.00'"
                                                                                            :disabled="readonly">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Unit Fees"
                                                                                label-for="linefees" label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        :debounce="sllines.debounce"
                                                                                        v-model="sllines.item.linefees"
                                                                                        placeholder="Unit Fees"
                                                                                        size="sm" trim
                                                                                        :disabled="readonly"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.linefees = '0.00'"
                                                                                            :disabled="readonly">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Unit VAT"
                                                                                label-for="linevat" label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        :debounce="sllines.debounce"
                                                                                        v-model="sllines.item.linevat"
                                                                                        placeholder="Unit VAT" size="sm"
                                                                                        trim
                                                                                        :disabled="readonly"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.linevat = '0.00'"
                                                                                            :disabled="readonly">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>

                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Unit Total"
                                                                                label-for="linetotal" label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        :debounce="sllines.debounce"
                                                                                        v-model="sllines.item.linetotal"
                                                                                        placeholder="Unit Total"
                                                                                        size="sm" trim
                                                                                        :disabled="true"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.linetotal = ''"
                                                                                            :disabled="true">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12"
                                                                                label="Supplier BL A/C" label-size="sm">
                                                                                <treeselect placeholder="Select blac..."
                                                                                    searchPromptText="Type at least 3 chars..."
                                                                                    v-model="sllines.item.blac"
                                                                                    :clearable="true" :async="true"
                                                                                    :load-options="treeselect_loadBLAC"
                                                                                    :show-count="true"
                                                                                    :flatten-search-results="true"
                                                                                    :disable-branch-nodes="true"
                                                                                    :matchKeys="['id']" search-nested
                                                                                    :disabled="readonly">
                                                                                    <div slot="value-label"
                                                                                        slot-scope="{ node }">
                                                                                        {{ node.raw.id }}
                                                                                    </div>
                                                                                </treeselect>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label-cols="12"
                                                                                label="Supplier Type" label-size="sm">
                                                                                <treeselect
                                                                                    placeholder="Select supplier type..."
                                                                                    searchPromptText="Supplier Type..."
                                                                                    v-model="sllines.item.bltype"
                                                                                    :clearable="true"
                                                                                    :options="options_suppliertype">
                                                                                </treeselect>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Supplier Type"
                                                                                label-for="type" label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        v-model="sllines.item.bltype"
                                                                                        placeholder="Supplier Type"
                                                                                        size="sm"
                                                                                        :disabled="false"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            :disabled="false"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.bltype = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col> -->
                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group
                                                                                label="Conferma Transaction ID"
                                                                                label-for="confermatransactionid"
                                                                                label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        v-model="sllines.item.confermatransactionid"
                                                                                        placeholder="Conferma Transaction ID"
                                                                                        size="sm"
                                                                                        :disabled="true"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            :disabled="true"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.confermatransactionid = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                        <b-col cols="12" sm="6" md="4" xl="3">
                                                                            <b-form-group label="Conferma Deployment ID"
                                                                                label-for="confermadeploymentid"
                                                                                label-cols="12">
                                                                                <b-input-group>
                                                                                    <b-form-input type="text"
                                                                                        v-model="sllines.item.confermadeploymentid"
                                                                                        placeholder="Conferma Deployment ID"
                                                                                        size="sm"
                                                                                        :disabled="true"></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button size="sm"
                                                                                            :disabled="true"
                                                                                            variant="outline-secondary"
                                                                                            @click="sllines.item.confermadeploymentid = ''">
                                                                                            <i class="fa fa-remove"></i>
                                                                                        </b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                            </b-form-group>
                                                                        </b-col>
                                                                    </b-row>



                                                                </div>
                                                            </b-card-body>

                                                        </b-card>
                                                    </p>
                                                </b-tab>


                                                <b-tab v-if="sllines.item.id">
                                                    <template #title>
                                                        <i class="fa fa-history text-primary mr-1"></i>Audit
                                                    </template>
                                                    <p class="py-3 px-0">
                                                        <b-row>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="ID" label-for="id" label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="sllines.item.id" placeholder=""
                                                                            size="sm" :disabled="true"></b-form-input>

                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                        </b-row>
                                                        <b-row>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Entry" label-for="entry"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="sllines.item.entry"
                                                                            placeholder="Entry" size="sm"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="true"
                                                                                variant="outline-secondary"
                                                                                @click="sllines.item.entry = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Accounting Period" label-for="ap"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text" v-model="item.ap"
                                                                            placeholder="Accounting Period" size="sm"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="true"
                                                                                variant="outline-secondary"
                                                                                @click="item.ap = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Period" label-for="period"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text" v-model="item.period"
                                                                            placeholder="Period" size="sm"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="true"
                                                                                variant="outline-secondary"
                                                                                @click="item.period = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Age" label-for="age"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text" v-model="item.age"
                                                                            placeholder="Age" size="sm"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm" :disabled="true"
                                                                                variant="outline-secondary"
                                                                                @click="item.age = ''">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>



                                                        </b-row>

                                                        <b-row>
                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Created At" label-for="created_at"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-input-group-prepend>
                                                                            <b-form-datepicker size="sm"
                                                                                v-model="sllines.item.created_at"
                                                                                button-only label-help="" locale="en-GB"
                                                                                :disabled="true"></b-form-datepicker>
                                                                        </b-input-group-prepend>
                                                                        <b-form-input size="sm" id="date"
                                                                            v-model="sllines.item.created_at"
                                                                            type="text" placeholder="YYYY-MM-DD"
                                                                            autocomplete="off"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="sllines.item.created_at = null"
                                                                                :disabled="true">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Created By" label-for="created_by"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="sllines.item.created_by"
                                                                            placeholder="" size="sm"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="sllines.item.created_by = ''"
                                                                                :disabled="true">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Updated At" label-for="updated_at"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-input-group-prepend>
                                                                            <b-form-datepicker size="sm"
                                                                                v-model="sllines.item.updated_at"
                                                                                button-only label-help="" locale="en-GB"
                                                                                :disabled="true"></b-form-datepicker>
                                                                        </b-input-group-prepend>
                                                                        <b-form-input size="sm" id="date"
                                                                            v-model="sllines.item.updated_at"
                                                                            type="text" placeholder="YYYY-MM-DD"
                                                                            autocomplete="off"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="sllines.item.updated_at = null"
                                                                                :disabled="true">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>

                                                            <b-col cols="12" sm="6" md="4" xl="3">
                                                                <b-form-group label="Updated By" label-for="updated_by"
                                                                    label-cols="12">
                                                                    <b-input-group>
                                                                        <b-form-input type="text"
                                                                            v-model="sllines.item.updated_by"
                                                                            placeholder="" size="sm"
                                                                            :disabled="true"></b-form-input>
                                                                        <b-input-group-append>
                                                                            <b-button size="sm"
                                                                                variant="outline-secondary"
                                                                                @click="sllines.item.updated_by = ''"
                                                                                :disabled="true">
                                                                                <i class="fa fa-remove"></i>
                                                                            </b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-row>

                                                    </p>
                                                </b-tab>
                                            </b-tabs>


                                            <!-- {{ mifields }} -->
                                            <b-row align-v="end" class="nopadding my-2 mt-4 background-transparent"
                                                no-gutters>
                                                <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                                                    MI Fields
                                                </b-col>
                                            </b-row>
                                            <b-row v-if="mifields.length > 0">
                                                <b-col cols="12" sm="6" md="4" xl="3"
                                                    v-for="(mifield, index) in mifields" :key="index">
                                                    <!-- <b-form-group :label="label(mifield)" label-cols="12" label-size="sm">-->
                                                    <b-form-group
                                                        :label="$helpers.requiredlabel(requirement, mifield.label)"
                                                        :class="$helpers
                                                            .requiredlabel(requirement, mifield.label)
                                                            .slice(0, 1) == '*'
                                                            ? 'text-danger'
                                                            : ''
                                                            " label-cols="12" label-size="sm">
                                                        <b-input-group>
                                                            <!-- :placeholder="placeholder(mifield)" :debounce="mifields.debounce" -->
                                                            <!-- v-model="mifields.args[mifield.key]"  -->
                                                            <b-form-input v-if="mifield.type == 'input'" type="text"
                                                                :disabled="mifield.active == '0'" size="sm" trim
                                                                v-model="mifield.value"
                                                                :placeholder="mifield.label"></b-form-input>

                                                            <!-- v-if="mifield.clearable" @click="mifields.args[mifield.key] = null"-->
                                                            <b-input-group-append v-if="mifield.type == 'input'"
                                                                @click="mifield.value = ''">
                                                                <b-button size="sm" variant="outline-secondary">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>

                                                        <!-- && filter.options
                      :multiple="filter.multiple == true ? true : false" -->
                                                        <!-- v-model="mifield.args[mifield.key]" :placeholder="mifield.placeholder"-->
                                                        <treeselect v-if="mifield.type == 'listofvalues'"
                                                            :show-count="true" :flatten-search-results="true"
                                                            :clearable="false" :disable-branch-nodes="true"
                                                            :matchKeys="['id']" search-nested :options="mifield.options"
                                                            v-model="mifield.value">
                                                        </treeselect>

                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row v-if="permissionvalid('systems.development')">
                                                <b-col cols="12">
                                                    <b-form-group label="Tags" label-for="tags" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="item.tags"
                                                                placeholder="Tags" size="sm" trim
                                                                :disabled="readonly"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled="readonly"
                                                                    variant="outline-secondary" @click="item.tags = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                            <b-row v-if="mifields.length == 0">
                                                <b-col>
                                                    There are no fields to display
                                                </b-col>
                                            </b-row>
                                            <b-row align-v="end" class="nopadding my-2 mt-4 background-transparent"
                                                no-gutters>
                                                <b-col class="divider"></b-col>
                                            </b-row>
                                            <div v-if="!sllines.edit">
                                                <b-row v-if="item.confermatransactionid" align-h="end" class="mt-2">
                                                    <b-col cols="12" sm="6" md="6" xl="6">
                                                        <b-form-group label-cols="12" label="Conferma Transaction ID"
                                                            label-size="sm" class="text-right">
                                                            <b-input-group>
                                                                <b-input-group-prepend>
                                                                    <b-button size="sm" variant="outline-primary"
                                                                        @click="confermatransactionid = null">
                                                                        <i class="fa fa-upload"></i>
                                                                    </b-button>
                                                                </b-input-group-prepend>
                                                                <b-form-tags input-id="confermatransactionid"
                                                                    v-model="confermatransactionid"
                                                                    tag-variant="primary" separator=" ,;/"
                                                                    placeholder="" size="sm" class="text-right h-29"
                                                                    add-button-text="+" add-on-change remove-on-delete
                                                                    add-button-variant="outline-primary"></b-form-tags>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="confermatransactionid = null">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>

                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>

                                                <b-row align-h="end" class="mt-2 ">
                                                    <b-col cols="12" sm="6" md="3" xl="3">
                                                        <b-form-group class="text-right"
                                                            label="Selection Unit Price GBP"
                                                            label-for="markup_lineprice" label-cols="12">
                                                            <b-input-group>
                                                                <b-input-group-prepend>
                                                                    <b-button size="sm" variant="outline-primary"
                                                                        title="Apply markup"
                                                                        @click="sllines_click('markup_lineprice', sllines.selected)">
                                                                        <i class="fa fa-line-chart"></i>
                                                                    </b-button>
                                                                </b-input-group-prepend>
                                                                <b-form-input type="text" v-model="markup_lineprice"
                                                                    placeholder="Markup GBP" size="sm"
                                                                    class="text-right"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="markup_lineprice = '0.00'">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col cols="12" sm="6" md="3" xl="3">
                                                        <b-form-group class="text-right"
                                                            label="Selection Unit Total GBP"
                                                            label-for="markup_linesubtotal" label-cols="12">
                                                            <b-input-group>
                                                                <b-input-group-prepend>
                                                                    <b-button size="sm" variant="outline-primary"
                                                                        title="Apply markup"
                                                                        @click="sllines_click('markup_linesubtotal', sllines.selected)">
                                                                        <i class="fa fa-line-chart"></i>
                                                                    </b-button>
                                                                </b-input-group-prepend>
                                                                <b-form-input type="text" v-model="markup_linesubtotal"
                                                                    placeholder="Markup Total GBP" size="sm"
                                                                    class="text-right"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="markup_linesubtotal = '0.00'">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                                <b-row align-h="end" class="mt-2 ">
                                                    <b-col cols="12" sm="6" md="3" xl="3">
                                                        <b-form-group class="text-right" label="Sale Total GBP"
                                                            label-for="markup_saletotal" label-cols="12">
                                                            <b-input-group>
                                                                <b-input-group-prepend>
                                                                    <b-button size="sm" variant="outline-primary"
                                                                        title="Apply markup"
                                                                        @click="sllines_click('markup_saletotal', sllines.selected)">
                                                                        <i class="fa fa-line-chart"></i>
                                                                    </b-button>
                                                                </b-input-group-prepend>
                                                                <b-form-input type="text" v-model="markup_saletotal"
                                                                    placeholder="Sale Total GBP" size="sm"
                                                                    class="text-right"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="markup_saletotal = '0.00'">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                            </div>


                                            <b-alert :show="changed" :variant="'primary'" class="text-center mt-2 mb-1">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-info-circle fa-2x"></i></b-col>
                                                    <b-col> <span
                                                            v-html="'Changes have been made - click \'Post It\' to save changes'"></span></b-col></b-row>
                                            </b-alert>

                                            <b-alert :show="locked" :variant="'danger'" class="text-center mt-2 mb-1">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-info-circle fa-2x"></i></b-col>
                                                    <b-col> <span
                                                            v-html="'Changes not permitted on this record - allocated to another entry'"></span></b-col></b-row>
                                            </b-alert>

                                        </b-tab>

                                    </b-tabs>
                                </p>

                            </b-tab>
                            <b-tab v-if="item.remittanceno" @click="remittance_load">
                                <template #title>
                                    <div class="badgecontainer pr-3 mr-1">
                                        <i class="fa fa-link text-orange mr-1"></i>
                                        {{ item.remittanceno }}
                                        <b-badge id="selection" variant="primary" class="edit_tab">
                                            {{ item.lines }}</b-badge>
                                    </div>
                                </template>
                                <b-row>
                                    <b-col>
                                        <b-alert :show="true" variant="secondary">
                                            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                    <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                <b-col>
                                                    <span class="h6"> This bank payment/receipt has the following
                                                        transaction references allocated.
                                                    </span></b-col></b-row>
                                        </b-alert></b-col>
                                </b-row>
                                <!-- <p class="py-3 px-0"> -->

                                <b-tabs class="z-0 relative">
                                    <b-tab>
                                        <!-- <template #title>
                                                <div class="badgecontainer pr-1 mr-1">
                                                    <i :class="remittance.icon" class="mr-1"></i> {{ item.remittanceno
                                                    }}
                                                    <b-badge variant="white" class="edit_tab">
                                                    </b-badge>

                                                </div>
                                            </template> -->
                                        <template #title>
                                            <div class="badgecontainer pr-2 mr-1">
                                                <i class="fa fa-table text-primary mr-1"></i>
                                                Transactions
                                            </div>
                                        </template>
                                        <b-row>
                                            <b-col>
                                                <d-table classdivtable="availtable datatable nested " refid="segments"
                                                    :icon="remittance.icon" :selectmode="'single'"
                                                    :busy="remittance.busy" :tools="remittance.tools"
                                                    :badges="remittance.badges" :fields="remittance.fields"
                                                    :selectall="remittance.selectall" :items="remittance.items"
                                                    :page="remittance.page" :limit="remittance.limit" :showpages="true"
                                                    @load="remittance_load" @click="remittance_click"
                                                    @select="remittance_select">
                                                </d-table>
                                                <div v-if="component">
                                                    <component :is="component" :selection="remittance.selected"
                                                        :config="cconfig" @discard="remittance_click('discard')"
                                                        @refresh="remittance_click('refresh')">
                                                    </component>
                                                </div>
                                            </b-col>
                                        </b-row>

                                    </b-tab>

                                </b-tabs>
                                <!-- </p> -->
                            </b-tab>
                            <b-tab>
                                <template #title>
                                    <i class="fa fa-comments-o text-primary mr-1"></i>
                                    Notes</template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Notes" label-for="notes" label-cols="12">
                                                <b-form-textarea id="data" v-model="item.notes" placeholder="Notes"
                                                    rows="6" class="smalltextarea"></b-form-textarea>
                                            </b-form-group> </b-col></b-row>
                                    <b-row class="mt-1">
                                        <b-col>
                                            <b-button squared size="sm" variant="outline-primary" class="mr-1"
                                                @click="timestamp">
                                                <i class="fa fa-clock-o"></i>
                                                Add a timestamp
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </p>
                            </b-tab>



                            <b-tab>
                                <template #title>
                                    <i class="fa fa-history text-primary mr-1"></i>Audit
                                </template>

                                <p v-if="idselected" class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="ID" label-for="id" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.id" placeholder="" size="sm"
                                                        :disabled="true"></b-form-input>

                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>
                                    <b-row>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Entry" label-for="entry" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.entry" placeholder="Entry"
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="true" variant="outline-secondary"
                                                            @click="item.entry = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Accounting Period" label-for="ap" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.ap"
                                                        placeholder="Accounting Period" size="sm"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="true" variant="outline-secondary"
                                                            @click="item.ap = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Period" label-for="period" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.period" placeholder="Period"
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="true" variant="outline-secondary"
                                                            @click="item.period = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Age" label-for="age" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.age" placeholder="Age"
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="true" variant="outline-secondary"
                                                            @click="item.age = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>
                                    <b-row>


                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="item.created_at"
                                                            button-only label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="item.created_at"
                                                        type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.created_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.created_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.created_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="item.updated_at"
                                                            button-only label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="item.updated_at"
                                                        type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.updated_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.updated_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.updated_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </p>
                            </b-tab>
                            <b-tab v-if="selection.length == 1">
                                <template #title>
                                    <i class="fa fa-wpforms text-info mr-1"></i>Invoice
                                </template>
                                <div class="etr">
                                    <b-row>
                                        <b-col cols="12">
                                            <r-invoice :invoiceno="item.invoiceno" />
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-tab>

                        </b-tabs>

                    </b-card-body>

                    <b-card-footer class="nopadding mt-2">
                        <b-row no-gutters>
                            <b-col cols="auto" class="text-left">
                                <b-button squared size="sm" variant="primary" @click="postit()"
                                    v-if="user.permissions.includes('salesledger.save')" :disabled="postit_disabled">
                                    <i class="fa fa-check"></i>
                                    Post It
                                </b-button>
                            </b-col>
                            <b-col class="text-left ml-2 mt-1">
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>
                            <b-col class="text-right" cols="8">
                                <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card-footer>
                </b-card>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "SLItemEdit",
    async mounted() {
        this.item.agent = this.user.initials;
        await this.bookingforms_load()
    },
    data() {
        return {
            busy: false,
            tabindex: 0,
            showHeader: false,
            mapper_date_at: {
                startDate: this.$moment().format("YYYY-MM-DD HH:mm"),
                endDate: this.$moment().format("YYYY-MM-DD HH:mm"),
            },
            mapper_travel_at: {
                startDate: null,
                endDate: null,
            },
            message: "",
            amount: "0.00",
            due: "0.00",
            markup_lineprice: "0.00",
            markup_linesubtotal: "0.00",
            markup_saletotal: "0.00",
            load_busy: false,
            confermatransactionid: [],
            confermadeploymentid: "",
            credit: false,
            credited: 0,
            locked: false,
            changed: false,
            options_suppliertype: [],
            vatcode_options: [
                { id: "0", label: "0" },
                { id: "1", label: "1" },
            ],
            bookingform_options: [],
            multiple: true,
            prefix_options: [
                {
                    id: "IM",
                    label: "IM | Manual Invoice"
                },
                {
                    id: "IT",
                    label: "IT | Accounts Invoice"
                },
                {
                    id: "IA",
                    label: "IA | Air Invoice"
                },
                {
                    id: "IC",
                    label: "IC | Carhire Invoice"
                },
                {
                    id: "IV",
                    label: "IV | Conferma Invoice"
                },
                {
                    id: "CM",
                    label: "CM | Credit Note"
                },
                {
                    id: "CV",
                    label: "CV | Conferma Credit"
                },
                {
                    id: "PP",
                    label: "PP | Payment Posting"
                },
                {
                    id: "PC",
                    label: "PC | Payment Credit"
                },
            ],
            item: {
                invoiceno: "*new",
                prefix: "IM",
                type: "A",
                date_at: this.$moment().valueOf().toString(),
                due_at: this.$moment().valueOf().toString(),
                slac: null,
                agent: null,
                ticketno: null,
                tickettype: null,
                taxes: "0.00",
                salevat: "0.00",
                amount: "0.00",
                due: "0.00",
                items: [{ id: "", name: "Passenger 1", ticketno: "abc" }],
            },
            sllines: {
                title: "Item Lines",
                icon: "fa fa-list text-info",
                debounce: 1000,
                busy: false,
                selectall: false,
                edit: false,
                tools: "go,export,clipboard,clone,edit,deleteconfirm",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    // {
                    //     key: "line",
                    //     label: "Line",
                    //     sortable: true,
                    // },
                    {
                        key: "ticketno",
                        label: "TicketNo",
                        sortable: true,
                    },
                    {
                        key: "tickettype",
                        label: "TicketType",
                        sortable: true,
                    },
                    {
                        key: "passenger",
                        label: "Passenger",
                        sortable: true,
                        class: "text-right",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 30) {
                                    result = result.slice(0, 27) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "route",
                        label: "Route",
                        sortable: true,
                        class: "text-right",
                    },
                    {
                        key: "travel_at",
                        label: "DateTravel",
                        sortable: true,
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment.unix(value * .001).utc(true).format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },

                    {
                        key: "qty",
                        label: "Qty",
                        sortable: true,
                        class: "text-right",
                    },
                    {
                        key: "lineprice",
                        label: "Unit Price Ex VAT",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "linetaxes",
                        label: "Unit Taxes",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "linesubtotal",
                        label: "Unit Subtotal Ex VAT",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "linefees",
                        label: "Unit Fees",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "linevat",
                        label: "Unit VAT",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "linetotal",
                        label: "Unit Total",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-right",
                    },
                ],
                badges: [],
                item: {},
                items: [],
                selected: []
            },
            remittance: {
                title: "Remittance",
                icon: "fa fa-link text-orange",
                debounce: 500,
                busy: false,
                selectall: false,
                limit: 100,
                tools: "go,export",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px text-primary",
                    },
                    {
                        key: "invoiceno",
                        label: "InvoiceNo",
                        sortable: true,
                        class: "text-right w-80px",
                    },
                    {
                        key: "invoice_at",
                        label: "Invoice At",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .format("DD/MM/YYYY HH:mm");
                            }
                            return result;
                        },
                    },
                    {
                        key: "creditno",
                        label: "CreditNo",
                        sortable: true,
                        class: "text-right w-80px",
                    },
                    {
                        key: "yourref",
                        label: "Your Ref/PO",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 20) {
                                    result = result.slice(0, 17) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "eventcode",
                        label: "Event",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "travel_at",
                        label: "DateTravel",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "amount",
                        label: "Amount",
                        sortable: true,
                        class: "text-right",
                        formatter: (value, key, item) => {
                            if (value) {
                                return parseFloat(value).toFixed(2);
                            } else {
                                return value;
                            }
                        },
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            return "BOP"
                        }
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-right",
                        // formatter: (value, key, item) => {
                        //     let result = "";
                        //     if (value) {
                        //         result = this.$moment
                        //             .unix(value / 1000)
                        //             .format("DD/MM/YYYY HH:mm");
                        //     }
                        //     return result;
                        // },
                    },

                    // {
                    //     key: "actions",
                    //     label: "Actions",
                    //     class: "actions w-100px w-sm-100pct",
                    // },
                ],
                badges: [
                    {
                        key: "credit",
                        type: "badge",
                        Credit: "danger",
                        Invoice: "primary",
                        formatter: (value, key, item) => {
                            if (value == true) {
                                return "Credit";
                            } else {
                                return "Invoice";
                            }
                        },
                    },
                ],
                item: {},
                items: [],
                selected: [],
                yourref: "",
                amount: 0,
            },
            mapper_ticketno_input: false,
            mapper_ticketno: [],        
            mapper_tickettype: [],
            // mapper_datetravel: []
        };
    },
    computed: {
        readonly() {
            if (this.user.initials == 'MR') {
                return false;
            }
            if (this.selection.length == 0) {
                return false;
            }
            if (this.user.permissions.includes('salesledger.admin')) {
                return false;
            }
            if (this.user.permissions.includes('salesledger.save') && this.item.age == 0) {
                return false
            }
            if (this.locked) {
                return true
            }
            return true;
        },
        readonly_formula() {
            if (this.selection.length == 0) {
                return false;
            }
            return true;
        },
        postit_disabled() {
            if (this.tabindex == 1) {
                return false
            }
            // if (this.user.initials == 'MR') {
            //     return false;
            // }
            if (this.user.department == 'ACCOUNTS') {
                return false;
            }
            return this.locked
        },
        min_qty() {
            if (this.sllines.item) {
                if (this.sllines.item.qty <= 0) {
                    return 1000 * Math.sign(this.sllines.item.qty)
                } else {
                    return 1 * Math.sign(this.sllines.item.qty)
                }
            } else {
                return 0
            }
        },
        max_qty() {
            if (this.sllines.item) {
                if (this.sllines.item.qty <= 0) {
                    return 1 * Math.sign(this.sllines.item.qty)
                } else {
                    return 1000 * Math.sign(this.sllines.item.qty)
                }
            } else {
                return 0
            }
        }
    },
    watch: {
        tabindex: {
            async handler(newVal, oldVal) {
                if (newVal == 4) {
                    this.item.invoiceno = ""
                    await this.load()
                }
                if (newVal == 1 || newVal == 2) {
                    this.sllines.selected = []
                    this.sllines.selectall = false
                    this.sllines.edit = false
                }
            }
        },
        mapper_date_at: {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.item.date_at = this.$moment(newVal.startDate).valueOf().toString()
                }
            }
        },
        mapper_travel_at: {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.sllines.item.travel_at = this.$moment(newVal.startDate).valueOf().toString()
                }
            }
        },
        "sllines.item.qty": {
            async handler(newVal, oldVal) {
                if (oldVal === undefined) {
                    return
                }
                console.log("watch:sllines.item.qty", parseFloat(newVal));
                if (newVal) {
                    if (Math.sign(newVal) == Math.sign(oldVal)) {
                        this.sllines.item.linesubtotal = (parseFloat(newVal) * Math.abs(parseFloat(this.sllines.item.lineprice)) + Math.abs(parseFloat(this.sllines.item.linetaxes))).toFixed(2)
                        this.message = ""
                    } else {
                        let msg = ""
                        if (parseFloat(this.sllines.item.qty) > 0) {
                            msg = "Credits MUST have -ve qty!"
                        } else {
                            msg = "Invoices MUST have +ve qty!"

                        }
                        this.message = "<span class='text-danger'>" + msg + "</span>"
                    }
                    this.changed = true
                }
            },
        },
        "sllines.item.lineprice": {
            async handler(newVal, oldVal) {
                if (oldVal === undefined) {
                    return
                }
                console.log("watch:sllines.item.lineprice", newVal);
                if (newVal) {
                    // this.sllines.item.linesubtotal = (parseFloat(this.sllines.item.qty) * (parseFloat(newVal) + Math.abs(parseFloat(this.sllines.item.linetaxes)))).toFixed(2)
                    this.changed = true
                    await this.sumsaletotal()
                }
            },
        },
        "sllines.item.linetaxes": {
            async handler(newVal, oldVal) {
                if (oldVal === undefined) {
                    return
                }
                console.log("watch:sllines.item.linetaxes", newVal);
                if (newVal) {
                    // this.sllines.item.linesubtotal = (parseFloat(this.sllines.item.qty) * (parseFloat(this.sllines.item.lineprice) + Math.abs(parseFloat(newVal)))).toFixed(2)
                    this.changed = true
                    await this.sumsaletotal()
                }
            },
        },
        "sllines.item.linesubtotal": {
            async handler(newVal, oldVal) {
                if (oldVal === undefined) {
                    return
                }
                if (newVal == 0) {
                    this.sllines.item.lineprice = "0.00"
                    this.sllines.item.linetaxes = "0.00"
                }
                console.log("watch:sllines.item.linesubtotal", newVal);
                if (newVal) {
                    // this.sllines.item.linetotal = (parseFloat(newVal) + parseFloat(this.sllines.item.linefees) + parseFloat(this.sllines.item.linevat)).toFixed(2)
                    this.changed = true
                    await this.sumsaletotal()
                }
            },
        },
        "sllines.item.linefees": {
            async handler(newVal, oldVal) {
                if (oldVal === undefined) {
                    return
                }
                console.log("watch:sllines.item.linefees", newVal);
                if (newVal) {
                    // this.sllines.item.linetotal = (parseFloat(this.sllines.item.linesubtotal) + parseFloat(newVal) + parseFloat(this.sllines.item.linevat)).toFixed(2)
                    this.changed = true
                    await this.sumsaletotal()
                }

            },
        },
        "sllines.item.linevat": {
            async handler(newVal, oldVal) {
                if (oldVal === undefined) {
                    return
                }
                console.log("watch:sllines.item.linevat", newVal);
                if (newVal) {
                    // this.sllines.item.linetotal = (parseFloat(this.sllines.item.linesubtotal) + parseFloat(this.sllines.item.linefees) + parseFloat(newVal)).toFixed(2)
                    this.changed = true
                    await this.sumsaletotal()
                }
            },
        },
        "sllines.item.linetotal": {
            async handler(newVal, oldVal) {
                if (oldVal === undefined) {
                    return
                }
                console.log("watch:sllines.item.linetotal", newVal);
            },
        },
        // DATA MAPPERS TO UI CONTROLS
        "sllines.item.ticketno": {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.mapper_ticketno = this.sllines.item.ticketno.split(",")
                }
            }
        },
        mapper_ticketno: {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.sllines.item.ticketno = newVal.join(",")
                }
            }
        },
        "sllines.item.tickettype": {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.mapper_tickettype = this.sllines.item.tickettype.split(",")
                }
            }
        },
        mapper_tickettype: {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.sllines.item.tickettype = newVal.join(",")
                }
            }
        },
        // "sllines.item.datetravel": {
        //     async handler(newVal, oldVal) {
        //         if (newVal) {
        //             this.mapper_datetravel = this.$moment.unix(newVal * 0.001).utc(true).format("YYYY-MM-DD")
        //         }
        //     }
        // },
        // mapper_datetravel: {
        //     async handler(newVal, oldVal) {
        //         if (newVal) {
        //             this.sllines.item.datetravel = this.$moment(newVal).valueOf().toString()
        //         }
        //     }
        // },
        // "item.confermatransactionid": {
        //     async handler(newVal, oldVal) {
        //         if (newVal) {
        //             this.confermatransactionid = this.item.confermatransactionid.split(",")
        //         }
        //     }
        // },
        "item.slac": {
            // deep: true,
            // immediate: true,
            async handler(newVal, oldVal) {
                console.log("watch:item.slac", newVal);
                let attributes = await this.$helpers.loadSLACAttributes(newVal);
                await this.load_mifields("true");
            },
        },
    },
    methods: {
        async loadDDL() {
            if (this.selection.length == 0) {
                this.showHeader = true
            }
        },
        async load() {
            if (this.selection.length == 1) {
                try {
                    const response = await this.$apollo.query({
                        query: gql`
                            query suppliertypes {
                                suppliertypes {
                                    id
                                    label
                                }
                            }
                            `,
                    });
                    this.options_suppliertype = response.data.suppliertypes;
                } catch (error) {
                    console.log(error);
                }
                await this.sllines_load();
            }
        },
        async bookingforms_load() {

            let variables = {
                status: 'submitted'
            };

            try {
                const response = await this.$apollo.query({
                    query: gql`
                query bookingforms($status: String) {
                    bookingforms(status: $status) {
                        id
                        label                        
                    }
                }
            `,
                    variables,
                });

                this.bookingform_options = response.data.bookingforms;
            } catch (error) {
                console.log(error);
            }

        },
        async sllines_load(offset, limit, page) {

            if (page) {
                this.sllines.page = page
            }

            this.sllines.busy = true;
            this.sllines.items = [];

            let requirements = "";
            for (var prop in this.requirement) {
                if (prop.slice(0, 3) != 'mi_') {
                    if (rows[0][prop] == null) {
                        requirements += this.requirement[prop] + ",";
                        break;
                    }
                }
            }
            requirements += await this.mifields_requirement()

            if (requirements.length > 0) {
                this.message =
                    "<span class='text-danger'>" +
                    requirements.slice(0, -1) +
                    " required field(s). </span>";
                this.busy = false;
                return;
            } else {
                this.message = ""
            }

            if (this.mifields.length > 0) {
                let tags = JSON.parse(this.item.tags || "{}");
                for (var k = 0; k < this.mifields.length; k++) {
                    tags[this.mifields[k].key] = this.mifields[k].value;
                }
                rows[0].tags = JSON.stringify(tags);
            }

            let variables = {
                id: this.selection[0].id,
            };

            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query SLTransactions($id: String) {
                            SLTransactions(id: $id) {
                            id
                            invoiceno
                            remittanceno
                            entry
                            confermatransactionid                            
                            credit
                            refcredit
                            # ref
                            to 
                            date_at
                            amount
                            due
                            prefix                         
                            dateref
                            yourref
                            yourrefbn
                            booker
                            slac
                            bltype
                            eventcode
                            passenger
                            travel_at
                            costexvat
                            saleexvat
                            salevat
                            saletotal
                            taxes
                            fees
                            outstanding
                            datedue
                            datepaid
                            cancelled
                            notes: comments
                            #comments
                            typeinv
                            age
                            period
                            ap
                            agent
                            lines
                            analysis1
                            analysis2
                            tags
                            created_at
                            created_by
                            updated_at
                            updated_by
                            locked
                            items {
                                id
                                confermatransactionid
                                confermadeploymentid
                                entry
                                line
                                blac
                                bltype
                                ticketno
                                tickettype
                                route
                                moreinfo
                                remark
                                slac 
                                passenger   
                                travel_at
                                qty
                                lineprice
                                linetaxes
                                linesubtotal
                                linefees
                                linevat
                                linetotal                            
                                created_at
                                created_by
                                updated_at
                                updated_by
                                iduid
                            }
                            }
                        }
                    `,
                    variables,
                    fetchPolicy: "no-cache",
                });

                this.locked = response.data.SLTransactions[0].locked

                this.item = response.data.SLTransactions[0]
                let startDate = this.$moment.unix(this.item.date_at * 0.001).utc(true).format("YYYY-MM-DD HH:mm")
                let endDate = startDate
                this.mapper_date_at = { startDate, endDate }

                if (this.item.confermatransactionid) {
                    this.confermatransactionid = this.item.confermatransactionid.split(',')
                }

                this.sllines.items = this.item.items;

                this.due = this.item.outstanding

                this.sumsaletotal()

                this.changed = false

            } catch (error) {
                console.log(error);
            }

            this.showHeader = false
            this.sllines.busy = false;
        },
        async sllines_click(a, ss) {
            console.log("lines_click", a, ss);

            let state = this.sllines;

            switch (a) {

                case "selectall":
                    state.selectall = !state.selectall
                    break;

                case "go":
                    this.component = null;
                    await this.sllines_load();
                    break;

                case "clone":
                    if (state.item) {
                        let copy = { ...state.item, id: "__copy", line: (this.sllines.items.length + 1).toString() }
                        delete copy.ticketno
                        delete copy.tickettype
                        // copy.travel_at = this.$moment(copy.travel_at).valueOf()
                        this.sllines.items.push(copy)
                    }
                    break;

                case "delete":
                    await this.lines_delete([state.item])
                    break;

                case "markup_lineprice":
                    for (var j = 0; j < this.sllines.selected.length; j++) {
                        this.sllines.selected[j].lineprice = (parseFloat(this.markup_lineprice)).toFixed(2)
                    }
                    this.sumsaletotal()
                    break;

                case "markup_linesubtotal":
                    for (var j = 0; j < this.sllines.selected.length; j++) {
                        if (this.markup_linesubtotal == 0) {
                            this.sllines.items[j].linetaxes = "0"
                        }
                        this.sllines.selected[j].lineprice = (parseFloat(this.markup_linesubtotal) - parseFloat(this.sllines.selected[j].linetaxes)).toFixed(2)
                    }
                    this.changed = true
                    this.sumsaletotal()
                    break;

                case "markup_saletotal":
                    let markup_total = parseFloat(this.markup_saletotal)
                    let markup_line = (markup_total / this.sllines.items.length).toFixed(2)
                    let markup_remainder = (markup_total - (markup_line * this.sllines.items.length)).toFixed(2)

                    console.log('set the markup total to', this.markup_saletotal, this.costtotal, markup_total, markup_line, markup_remainder)
                    for (var j = 0; j < this.sllines.items.length; j++) {
                        if (this.markup_saletotal == 0) {
                            this.sllines.items[j].linetaxes = "0"
                            this.sllines.items[j].linefees = "0"
                        }
                        if (j < this.sllines.items.length - 1) {
                            this.sllines.items[j].lineprice = (parseFloat(markup_line) - parseFloat(this.sllines.items[j].linetaxes)).toFixed(2)
                        } else {
                            this.sllines.items[j].lineprice = ((parseFloat(markup_line) - parseFloat(this.sllines.items[j].linetaxes)) + parseFloat(markup_remainder)).toFixed(2)
                        }
                    }
                    this.changed = true
                    this.sumsaletotal()
                    break;

                case "edit":
                    state.edit = !state.edit
                    break;

                case "save":
                    await this.lines_saveit()
                    break;

            }
        },
        async sllines_select(ss, tools) {
            console.log("sllines_select", ss);

            let state = this.sllines;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "add", "export", "clipboard"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "clone", "notes"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            if (state.selected.length > 0) {
                state.item = state.selected[0]  // WHAT YOU SELECTED

                if (state.item.travel_at) {
                    let startDate = this.$moment.unix(state.item.travel_at * 0.001).utc(true).format("YYYY-MM-DD")
                    let endDate = startDate
                    this.mapper_travel_at = { startDate, endDate }
                }

            } else {
                state.item = {}
            }
        },

        async sllines_save(ss) {
            this.sllines.busy = true;

            let variables = {
                rows: this.cleanit(ss),
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation SL_lineitems_save($rows: [SLTransactionitem_input]) {
                        SL_lineitems_save(rows: $rows) {
                            id
                        }
                    }
                    `,
                    variables,
                });

                this.message = "<span class='text-primary'>Saved it.</span>";
                this.sllines.busy = false;

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            await this.sllines_load()
        },
        async sllines_delete(ss) {
            this.sllines.busy = true;

            let variables = {
                rows: [{ id: this.sllines.item.iduid }],
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation SL_lineitems_delete($rows: [SLTransactionitem_input]) {
                        SL_lineitems_delete(rows: $rows) {
                            id
                        }
                    }
                    `,
                    variables,
                });

                this.message = "<span class='text-primary'>Deleted it.</span>";
                this.sllines.busy = true;

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            await this.sllines_load()
        },
        async remittance_load(offset, limit, page) {


            if (page) {
                this.remittance.page = page
            }

            // if (!this.agent) { return }

            this.remittance.busy = true;
            this.remittance.items = [];

            let variables = {
                invoiceno: this.selection[0].invoiceno,
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query SLTransactions($invoiceno: String) {
                            SLTransactions(invoiceno: $invoiceno) {
                            invoiceno                          
                            remittance {
                                invoiceno
                                invoice_at
                                creditno
                                yourref
                                slac
                                eventcode
                                travel_at
                                amount: valuecleared
                                updated_at
                            }
                        }
                    }
                `,
                    variables,
                });


                if (response.data.SLTransactions[0].remittance) {

                    // this.item = response.data.SLTransactions[0].remittance
                    // this.item.date = this.$moment.unix(this.item.date * 0.001).utc(false).format("YYYY-MM-DD");

                    this.remittance.items = response.data.SLTransactions[0].remittance
                    if (this.remittance.items.length > 0) {
                        this.remittance.amount = this.remittance.items[0].amount
                        this.remittance.yourref = this.remittance.items[0].yourref
                    }

                } else {

                    // this.item.invoiceno = "PP<new>"
                    // this.item.date = this.$moment().format("YYYY-MM-DD")
                    // this.item.slac = this.selection[0].slac
                    // this.item.yourref = "BACS " + this.$moment().format("DD.MM.YY")
                    // this.remittance.items = this.selection

                }

            } catch (error) {
                console.log(error);
            }
            this.remittance.busy = false;
        },


        async remittance_click(a, ss) {
            console.log("remittance_click", a, ss);

            let state = this.remittance;

            switch (a) {
                case "selectall":
                    this.remittance.selectall = !this.remittance.selectall
                    break;
                case "go":
                    this.component = null;
                    await this.remittance_load();
                    break;

                case "save":
                    await this.remittance_saveit()
                    break;

                case "delete":
                    this.deleteit(ss);
                    break;

            }
        },
        async remittance_select(ss, tools) {
            console.log("remittance_select", ss);

            let state = this.remittance;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "add", "export"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "notes"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            this.credited = 0
            if (state.selected.length > 0) {
                let value = 0
                state.selected.forEach(function (action, index) {
                    value += parseFloat(state.selected[index].saletotal)
                })
                this.credited = value
            } else {
                state.item = {}
            }
        },

        async remittance_saveit() {
            this.busy = true;

            let state = this.remittance;

            // ONLY SEND WHAT WE ARE ALLOWED TO UPDATE
            let rows = []
            for (var i = 0; i < state.selected.length; ++i) {
                rows.push({
                    // id: state.selected[i].id,
                    // eventcode: state.selected[i].eventcode,
                    // slac: state.selected[i].slac,
                })
            }

            let variables = {
                rows,
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
            mutation saveSLTransactions($rows: [SLTransaction_input]) {
                saveSLTransactions(rows: $rows) {
                id
                }
            }
            `,
                    variables,
                });

                await this.remittance_load()

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },

        async deleteit(s) {
            console.log("deleteit", s);

            let rows = [];
            s.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            console.log(variables);
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation deleteSLTransaction($rows: [SLTransaction_input]) {
                    deleteSLTransaction(rows: $rows) {
                        id
                    }
                    }
                    `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.sltransactions_load();
        },
        async saveit() {
            this.busy = true;

            console.log(this.item.tags)
            let ss = this.selection

            let rows = []
            for (var i = 0; i < ss.length; ++i) {
                rows.push({
                    entry: ss[i].entry,
                    refcredit: this.item.refcredit ? this.item.refcredit : "",
                    agent: this.item.agent,
                    yourrefbn: this.item.yourrefbn ? this.item.yourrefbn : "",
                    slac: this.item.slac,
                    eventcode: this.item.eventcode,
                    analysis1: this.item.analysis1,
                    analysis2: this.item.analysis2,
                    tags: this.item.tags,
                    notes: this.item.notes,
                    items: this.sllines.items
                })
            }

            let variables = {
                rows,
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation SL_save($rows: [SLTransaction_input]) {
                        SL_save(rows: $rows) {
                        id
                        }
                    }
                    `,
                    variables,
                });

                // await this.load()
                this.message = "<span class='text-primary'>Saved it.</span>";

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
            // await this.sllines_load();
        },

        async postit() {

            await this.saveit()

        },

        sumsaletotal() {

            this.amount = 0
            if (this.sllines.items) {
                for (var j = 0; j < this.sllines.items.length; j++) {


                    if (isNaN(this.sllines.items[j].lineprice)) { this.sllines.items[j].lineprice = "0" }
                    this.sllines.items[j].lineprice = parseFloat(Math.abs(this.sllines.items[j].lineprice)).toFixed(2)

                    let sign = Math.sign(this.sllines.items[j].qty)
                    let price = parseFloat(Math.abs(this.sllines.items[j].lineprice))
                    let tax = parseFloat(Math.abs(this.sllines.items[j].linetaxes))
                    let qty = Math.abs(this.sllines.items[j].qty)
                    this.sllines.items[j].linesubtotal = (((price + tax) * qty) * sign).toFixed(2);

                    if (isNaN(this.sllines.items[j].linevat)) { this.sllines.items[j].linevat = "0" }
                    this.sllines.items[j].linevat = parseFloat(this.sllines.items[j].linevat).toFixed(2)
                    this.sllines.items[j].linetotal = (parseFloat(this.sllines.items[j].linesubtotal) + parseFloat(this.sllines.items[j].linefees) + parseFloat(this.sllines.items[j].linevat)).toFixed(2);

                    this.amount += parseFloat(this.sllines.items[j].linetotal)

                }
            }
            this.markup_saletotal = this.amount.toFixed(2)
            if (this.item.outstanding = this.item.saletotal) {
                this.due = this.markup_saletotal
            }
            console.log('sumsaletotal', this.amount)
        },
    },
};
</script>